import {
  EN_US_LANGUAGE,
  NON_EDUCATIONAL_LANGUAGE,
  ONE_YEAR_IN_DAYS,
  PT_BR_LANGUAGE,
  SELECTED_LANGUAGE_COOKIE_NAME,
  i18n
} from 'i18n'
import { useEffect } from 'react'
import { getCookie, setCookieOnDomain } from 'utils/cookies'
import { useUserInfo } from '../use-userInfo'

export const useLanguageCheck = () => {
  const { user } = useUserInfo()

  function checkLanguageState(
    currentSelectedLanguage: string,
    isNonEducationalContext: boolean,
    hasStoryTree: boolean
  ) {
    let shouldChangeLanguage = false
    let language = ''

    if (
      isNonEducationalContext &&
      [PT_BR_LANGUAGE, ''].includes(currentSelectedLanguage)
    ) {
      shouldChangeLanguage = true
      language = NON_EDUCATIONAL_LANGUAGE
    }

    if (
      !isNonEducationalContext &&
      currentSelectedLanguage === NON_EDUCATIONAL_LANGUAGE
    ) {
      shouldChangeLanguage = true
      language = PT_BR_LANGUAGE
    }

    if (
      hasStoryTree &&
      !isNonEducationalContext &&
      currentSelectedLanguage !== EN_US_LANGUAGE
    ) {
      shouldChangeLanguage = true
      language = EN_US_LANGUAGE
    }

    return { shouldChangeLanguage, language }
  }

  useEffect(() => {
    const currentSelectedLanguage = getCookie(SELECTED_LANGUAGE_COOKIE_NAME)
    const isNonEducationalContext = user?.isContextNonEducational
    const hasStoryTree = Boolean(user?.featureToggles?.storyTree)
    const { shouldChangeLanguage, language } = checkLanguageState(
      currentSelectedLanguage,
      isNonEducationalContext,
      hasStoryTree
    )

    if (shouldChangeLanguage) {
      i18n.changeLanguage(language)

      setCookieOnDomain(
        SELECTED_LANGUAGE_COOKIE_NAME,
        language,
        ONE_YEAR_IN_DAYS
      )
    }
  }, [user?.isContextNonEducational, user?.featureToggles?.storyTree])
}
